import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { BRAND } from '../brand';

/**
 * EmailVerificationPage - Backward compatibility redirect
 * 
 * This component redirects to the unified AuthActionPage handler.
 * It maintains backward compatibility for existing email verification links
 * that use the /verify-email route.
 */
const EmailVerificationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    // Redirect to unified auth action handler with the same query parameters
    const queryString = searchParams.toString();
    const redirectUrl = queryString ? `/auth-action?${queryString}` : '/auth-action';
    navigate(redirectUrl, { replace: true });
  }, [searchParams, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 rounded-2xl flex items-center justify-center shadow-lg">
            <img src={BRAND.logoSrc} alt={BRAND.name} className="h-16 w-16" />
          </div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-gray-100">
            Redirecting...
          </h2>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 space-y-6">
          <div className="text-center space-y-4">
            <div className="flex justify-center">
              <svg className="animate-spin h-12 w-12 text-green-600 dark:text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </div>
            <p className="text-gray-600 dark:text-gray-400">Redirecting to action handler...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationPage;

